import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

type TUseAddGoalFocusAreaMutation = {
  options?: any;
};

export const useAddGoalFocusAreaMutation = ({
  options,
}: TUseAddGoalFocusAreaMutation) => {
  const { goalId } = useParams();

  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({ title }: { title: string; id: string }) =>
      request({
        url: `/api/web/goals/${goalId}/breakdown/focus-areas/create`,
        body: { title },
      }),
    {
      ...options,
    }
  );
};
